import { FormControl, FormGroup } from '@angular/forms';

export class ConventionRegistrationSectoralMeetingExtension {
    name: string = null;
    startDate: string = null;
    startTime: string = null;
    room: string = null;
    selected: boolean = false;

    /**
     * Override the default validation controls to set
     * @param form
     */
    static overrideDefaultForm(form: FormGroup, disableAll: boolean = false) {
        form.addControl('name', new FormControl({ value: null, disabled: disableAll }));
        form.addControl('startDate', new FormControl({ value: null, disabled: disableAll }));
        form.addControl('startTime', new FormControl({ value: null, disabled: disableAll }));
        form.addControl('room', new FormControl({ value: null, disabled: disableAll }));
        form.addControl('selected', new FormControl({ value: false, disabled: disableAll }));
    }
}
